<template>
  <div>
    <div class="hslx-icon">
      <img @click="handleClick" src="../../../../assets/images/icon_hslx.png" />
      <div :style="{pointerEvents: showCard ? '' : 'none'}" class="card-container">
        <div :style="{right: showCard ? 0 : ''}" class="card-animation">
          <div class="card-item customized-route">
            <div class="card-item" @click.stop="handleNewRoad">
              <img src="../../../../assets/images/icon_new_road.png" />
              <span>定制路线</span>
            </div>
            <div class="icon-down" @click="handleToggleMyRoute">
              <img
                :style="{transform: showMyRoute ? '' : 'rotate(180deg)'}"
                src="@/assets/images/icon_down_red.png"
              />
            </div>
            <div :style="{opacity: showMyRoute ? 1 : '', top: showMyRoute ? '0.9rem' : ''}" ref="myRoute" @click.stop="handleMyRoad" class="card-item drop-down">
              <img src="../../../../assets/images/icon_my_road.png" />
              <span>我的路线</span>
            </div>
          </div>
          <div v-if="isEnabledRecommendRoute" ref="myRoute" @click.stop="handleRecommendRoute" class="card-item recommend-route">
            <img src="../../../../assets/images/icon_my_recommend.png" />
            <span>{{recommendRouteText}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import openApp from '../../../../utils/openApp'
import { buryingPoint } from '@/utils/buryingPoint'

export default {
  name: 'ClockIcon',
  computed: {
    ...mapGetters({
      systemInfo: 'systemInfo',
      selectedCity: 'home/selectedCity',
      activityId: 'activityInfo/activityId',
      userInfo: 'userInfo/userInfo',
      activityInfo: 'activityInfo/activityInfo',
    }),
    isEnabledRecommendRoute() {
      return this.activityInfo?.mapStyle?.fnModule?.recommendRoute?.check
    },
    recommendRouteText() {
      return this.activityInfo?.mapStyle?.fnModule?.recommendRoute?.text
    }
  },
  data() {
    return {
      showCard: false,
      showMyRoute: false,
    }
  },
  methods: {
    ...mapMutations({
      toast: 'toast/showToast',
    }),
    handleToggleMyRoute() {
      buryingPoint({ action: 11, sourceTag: 2, activityId: this.activityId, itemType: 2 })
      this.showMyRoute = !this.showMyRoute
    },
    async handleClick() {
      buryingPoint({ action: 10, sourceTag: 2, activityId: this.activityId, itemType: 2 })
      if (this.systemInfo.isWx || this.systemInfo.isNfPlus) {
        this.showCard = !this.showCard
        if(!this.showCard) {
          this.showMyRoute = false
        }
      } else {
        openApp(
          {
            address:
              window.location.origin +
              window.location.pathname +
              this.$router.resolve({
                path: '/',
                query: { id: this.activityId },
              }).href,
          },
          this.activityId,
          40
        )
      }
    },
    /**跳转定制路线页面 */
    async handleNewRoad() {
      buryingPoint({ action: 11, sourceTag: 2, activityId: this.activityId, itemType: 2 })
      if (!this.userInfo.userUuid) {
        await this.$store.dispatch('userInfo/getUserInfo')
      }
      if (!this.userInfo.userUuid && this.systemInfo.isNfPlus) {
        await this.$store.dispatch('userInfo/getNfplusUserByLogin')
      }
      if (this.selectedCity?.code === '440000' || this.selectedCity?.code === '') {
        this.toast('请选择游览城市再定制路线')
        return
      }
      this.$router.push({
        path: '/createRoute',
        query: { id: this.activityId },
      })
    },
    /**跳转我的路线页面 */
    async handleMyRoad() {
      if (!this.userInfo.userUuid) {
        await this.$store.dispatch('userInfo/getUserInfo')
      }
      if (!this.userInfo.userUuid && this.systemInfo.isNfPlus) {
        await this.$store.dispatch('userInfo/getNfplusUserByLogin')
      }
      this.$router.push({
        path: '/lineRouteItem',
        query: { id: this.activityId },
      })
    },
    handleRecommendRoute() {
      this.showCard = false
      this.showMyRoute = false
      const query = { id: this.activityId }
      const shopId = this.$route.query?.shopId
      if (shopId) {
        query.shopId = shopId
      }
      this.$router.push({ path: "/recommendRoute", query })
    }
  },
}
</script>
<style lang="scss" scoped>
$card_height: 0.9rem;

.hslx-icon {
  width: 1.06rem;
  height: 1.06rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  img {
    width: 1.06rem;
    display: inline-block;
  }
  span {
    font-size: 0.24rem;
    color: #333;
  }
  .card-container {
    position: absolute;
    top: 0;
    right: 0.5rem;
    width: 6.5rem;
    height: 2rem;
    z-index: -1;
    overflow: hidden;
  }
  .card-animation {
    position: absolute;
    right: -100%;
    padding-left: 0.35rem;
    padding-right: 0.5rem;
    box-sizing: border-box;
    max-width: 6.5rem;
    height: $card_height;
    background: #fff;
    border: 0.02rem solid #ee3611;
    border-radius: 0.45rem 0px 0px 0.45rem;
    transition: right 0.5s, transform 0.5s;
    display: flex;
    justify-items: center;
    align-items: center;
    .customized-route {
      width: 2rem;
      & + div.recommend-route {
        margin-left: 0.4rem;
      }
    }
    .recommend-route{
      max-width: 3.2rem;
    }
    .card-item {
      position: relative;
      text-align: center;
      height: $card_height;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-wrap: nowrap;
      & > .icon-down {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 10;
        width: 0.38rem;
        height: 100%;
        text-align: left;
        & > img {
          width: 0.18rem;
          height: 0.1rem;
          object-fit: contain;
          transition: transform 0.3s ease-in-out;
        }
      }
      & > img {
        width: 0.3rem;
        height: 0.3033rem;
        margin-right: 0.05rem;
        vertical-align: middle;
      }
      & > span {
        font-size: 0.3rem;
        color: #ab051b;
        font-weight: 500;
        margin-left: 0.05rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      & + .card-item {
        margin-left: 0.2rem;
      }
    }

    .drop-down {
      position: absolute;
      z-index: -1;
      width: 2.24rem;
      height: $card_height;
      top: 0;
      left: -0.35rem;
      margin-top: 0.1rem;
      background-color: white;
      box-shadow: 0.04rem 0.04rem 0.08rem 0 rgba(202,105,105,0.5);
      border-radius: 0.45rem;
      opacity: 0;
      transition: top 0.3s ease-in-out, opacity 0.3s ease-in-out;
    }
  }
}
.hslx-icon-middle {
  bottom: 4.65rem;
}
.hslx-icon-top {
  bottom: 5.75rem;
}
</style>
